module.exports = __webpack_public_path__ + "img/store_vip_banner_arrow.2decb301.png";